import { detectEnvironment } from '@/utils/detectEnvironment';

/**
 * Generates the gxgo config API endpoint URL with environment-specific name.
 * For staging: /config/gxgo_staging
 * For production/other: /config/gxgo
 *
 * @returns The full gxgo config endpoint URL
 */
export const getGxgoConfigApiUrl = () =>
  detectEnvironment() === 'staging' ? '/config/gxgo_staging' : '/config/gxgo';
